<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<h2>Tous les horaires</h2>

	<mat-form-field>
		<mat-label>Recherche (nom, magasin, activité…)</mat-label>
		<input matInput (keyup)="applyFilter($event)">
	</mat-form-field>

	<!-- Un service accumule une grille par période : par défaut on ne montre que ce qui sert
	     encore (en cours + à venir), les archives restent à un clic. -->
	<mat-button-toggle-group class="scope-filter" [value]="scope" (change)="onScope($event.value)" aria-label="Périodes affichées">
		<mat-button-toggle value="live" matTooltip="Les grilles qui s'appliquent aujourd'hui ou plus tard">
			Actuels &amp; à venir ({{ counts.live }})
		</mat-button-toggle>
		<mat-button-toggle value="past" matTooltip="Les grilles dont la période est terminée">Passés ({{ counts.past }})</mat-button-toggle>
		<mat-button-toggle value="all">Tous ({{ counts.all }})</mat-button-toggle>
	</mat-button-toggle-group>

	<span class="spacer"></span>
	<!-- Imprimer CE QUI EST AFFICHÉ : les filtres ci-dessus composent le document (les horaires
	     en cours et à venir d'un magasin, par exemple), une grille par page.
	     Même place que sur le planning et dans l'éditeur : icône seule, juste avant l'action
	     principale de l'écran. -->
	<button mat-icon-button id="printschedulesbutton" aria-label="Imprimer" (click)="onPrintAll()"
		matTooltip="Imprimer les grilles affichées — une page par service, roulement compris">
		<mat-icon>print</mat-icon>
	</button>
	<button mat-flat-button color="primary" id="newschedulebutton" (click)="onNew()">
		<mat-icon>post_add</mat-icon>&nbsp;Nouvel emploi du temps
	</button>
</div>

<div class="pagecontent">
	<table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Nom</th>
			<td mat-cell *matCellDef="let row">{{ row.name }}</td>
		</ng-container>
		<ng-container matColumnDef="store">
			<th mat-header-cell *matHeaderCellDef>Magasin</th>
			<td mat-cell *matCellDef="let row">{{ row.store }}</td>
		</ng-container>
		<ng-container matColumnDef="activity">
			<th mat-header-cell *matHeaderCellDef>Activité</th>
			<td mat-cell *matCellDef="let row">{{ row.activity }}</td>
		</ng-container>
		<ng-container matColumnDef="period">
			<th mat-header-cell *matHeaderCellDef>Période</th>
			<td mat-cell *matCellDef="let row">{{ row.period }}</td>
		</ng-container>
		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef>Statut</th>
			<td mat-cell *matCellDef="let row">
				<span class="status-chip" [class]="row.status">{{ row.statusLabel }}</span>
			</td>
		</ng-container>
		<ng-container matColumnDef="cycle">
			<th mat-header-cell *matHeaderCellDef>Rotation</th>
			<td mat-cell *matCellDef="let row">{{ row.cycle }}</td>
		</ng-container>
		<ng-container matColumnDef="members">
			<th mat-header-cell *matHeaderCellDef>Effectif</th>
			<td mat-cell *matCellDef="let row">{{ row.members }}</td>
		</ng-container>
		<ng-container matColumnDef="active">
			<th mat-header-cell *matHeaderCellDef>Actif</th>
			<td mat-cell *matCellDef="let row">
				<mat-icon [class.inactive]="!row.active">{{ row.active ? 'check_circle' : 'cancel' }}</mat-icon>
			</td>
		</ng-container>

		<tr mat-header-row class="table_head" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row" [class.past]="row.status === 'past'"
			(click)="onClickRow(row)"></tr>
	</table>

	@if (loaded && dataSource.filteredData.length === 0) {
		<div class="hr-empty">
			@if (counts.all === 0) {
				Aucun horaire type. Créez par exemple « Ollioules — Magasin » et « Ollioules — Livraison »
				avec « Nouvel emploi du temps ».
			} @else if (scope === 'live') {
				Aucune grille en cours ni à venir — regardez les <button mat-button (click)="onScope('past')">passés ({{ counts.past }})</button>
				ou créez la suite avec « Nouvel emploi du temps ».
			} @else {
				Aucune grille ne correspond à cette recherche.
			}
		</div>
	}
</div>
